import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core'
import { MbCheckoutRegions, MbPaymentMode, MbPaymentModeSelection } from '../../../models'
import { Subscription } from 'rxjs'
import { MbConstants } from '../../../shared/mb-constants'
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms'
import { MbCheckoutBillingFacade } from '../../facades/mb-checkout-billing.facade'

@Component({
  selector: 'mb-checkout-billing-common-payment-info-tile',
  templateUrl: './mb-checkout-billing-common-payment-info-tile.component.html',
  styleUrls: ['./mb-checkout-billing-common-payment-info-tile.component.scss']
})
export class MbCheckoutBillingCommonPaymentInfoTileComponent implements OnInit, OnDestroy {

  checkoutRegions = MbCheckoutRegions
  @Input() paymentMode: MbPaymentMode | undefined

  poNo: string = ''
  @Input() set poNumber (poNumber: string) {
    this.poNo = poNumber
    this.form?.patchValue({ poNumber: poNumber })
  }

  @Input() formRegion = this.checkoutRegions.EU

  @Output() paymentModeSelected = new EventEmitter<MbPaymentModeSelection>()

  subscription = new Subscription()
  constants = MbConstants
  form = new UntypedFormGroup({
    poNumber: new UntypedFormControl(this.poNo, Validators.required)
  })

  constructor (protected mbCheckoutBillingService: MbCheckoutBillingFacade) {
  }

  ngOnInit () {
    this.subscription?.add(this.mbCheckoutBillingService.isPoNumberFieldInvalid.subscribe(isInvoiceFieldInValid => {
      if (isInvoiceFieldInValid) {
        this.form?.markAllAsTouched()
      }
    }))
  }

  ngOnDestroy () {
    this.subscription?.unsubscribe()
  }

  onPaymentModeSelected (value?: MbPaymentMode) {
    this.paymentModeSelected.emit({ paymentMode: value, poNumber: this.poNo })
  }

  submitPoNumber () {
    this.poNo = this.form?.get(this.constants.PO_NUMBER_CODE)?.value
    if (!this.form?.valid) {
      this.form?.markAllAsTouched()
    }
    this.onPaymentModeSelected(this.paymentMode)
  }

}
